import { utils, config } from "../../../../studentportal-sdk";

export const getAllAssessment = async () => {
  try {
    const { data } = await utils
      .apiConnect()
      .get(config.domains.endpoints.getAllAssessmentApi);
    return {
      status: true,
      data: data.data,
      message: data.message,
    };
  } catch (error) {
    return {
      status: false,
      message: error?.response?.data?.message || error.message,
      error: true,
    };
  }
};

export const submitAnswer = async (formdata) => {
  try {
    const { data } = await utils
      .apiConnect()
      .post(config.domains.endpoints.submitAnswerApi, formdata);
    return {
      status: true,
      data: data.data,
      message: data.message,
    };
  } catch (error) {
    return {
      status: false,
      message: error?.response?.data?.message || error.message,
      error: true,
    };
  }
};

export const addAssessment = async(formdata) => {
    try{
        const {data} = await utils.apiConnect().post(config.domains.endpoints.postAssessmentApi, formdata)
        return {
            status: true,
            data: data.data,
            message: data.message
        }
    }catch(error){
        return {
            status: false,
            message: error?.response?.data?.message || error.message,
            error: true
        }
    }
}

export const updateAssessment = async(formdata) => {
    try{
        const {data} = await utils.apiConnect().put(config.domains.endpoints.updateAssessmentApi, formdata)
        return {
            status: true,
            data: data.data,
            message: data.message
        }
    }catch(error){
        return {
            status: false,
            message: error?.response?.data?.message || error.message,
            error: true
        }
    }
}
export const enrollForAssessment = async (formdata) => {
  try {
    const { data } = await utils
      .apiConnect()
      .post(config.domains.endpoints.enrollForAssessmentApi, formdata);
    return {
      status: true,
      data: data.data,
      message: data.message,
    };
  } catch (error) {
    return {
      status: false,
      message: error?.response?.data?.message || error.message,
      error: true,
    };
  }
};

export const createQuestion = async(formdata) => {
    try{
        const {data} = await utils.apiConnect().post(config.domains.endpoints.postQuestionApi, formdata)
        return {
            status: true,
            data: data.data,
            message: data.message
        }
    }catch(error){
        return {
            status: false,
            message: error?.response?.data?.message || error.message,
            error: true
        }
    }
}

export const getQuestions = async (formdata) => {
    try {
        const { assessmentId} = formdata
      const { data } = await utils
        .apiConnect()
        .get(config.domains.endpoints.getAllQuestionsApi+`?assessmentId=${assessmentId}`);
      return {
        status: true,
        data: data.data,
        message: data.message,
      };
    } catch (error) {
      return {
        status: false,
        message: error?.response?.data?.message || error.message,
        error: true,
      };
    }
  };

  export const getQuestion = async (questionId) => {
    try {
      const { data } = await utils
        .apiConnect()
        .get(config.domains.endpoints.nextQuestionApi+`?questionId=${questionId}`);
      return {
        status: true,
        data: data.data,
        message: data.message,
      };
    } catch (error) {
      return {
        status: false,
        message: error?.response?.data?.message || error.message,
        error: true,
      };
    }
  };

    export const getAssessmentResult = async (assessmentId) => {
    try {
      const { data } = await utils
        .apiConnect()
        .get(config.domains.endpoints.assessmentResultApi+`?assessmentId=${assessmentId}`);
      return {
        status: true,
        data: data.data,
        message: data.message,
      };
    } catch (error) {
      return {
        status: false,
        message: error?.response?.data?.message || error.message,
        error: true,
      };
    }
  };

  export const getEnrolledAssessment = async (userId) => {
    try {
      const { data } = await utils
        .apiConnect()
        .get(config.domains.endpoints.getEnrolledAssessmentApi+`?userId=${userId}`);
      return {
        status: true,
        data: data.data,
        message: data.message,
      };
    } catch (error) {
      return {
        status: false,
        message: error?.response?.data?.message || error.message,
        error: true,
      };
    }
  };

  export const startAssessment = async (formdata) => {
    try {
      const { data } = await utils
        .apiConnect()
        .post(config.domains.endpoints.enrollForAssessmentApi,formdata);
      return {
        status: true,
        data: data.data,
        message: data.message,
      };
    } catch (error) {
      return {
        status: false,
        message: error?.response?.data?.message || error.message,
        error: true,
      };
    }
  };


